// extracted by mini-css-extract-plugin
module.exports = {"priceSection":"i4fra5","prices":"_2Z_Jcc","shine-lines":"_2Fyrz_"};